import { type FC } from "react"
import { Navigate, useParams } from "react-router"

import { parseNumber } from "@forento/shared/utilities/number"

import Button from "~/themes/original/components/Button"
import Layout from "~/themes/original/components/Layout"
import PartialLoadingPage from "~/themes/original/components/PartialLoadingPage"
import ProductDetail from "~/themes/original/components/ProductDetail"
import routes from "~/utilities/routes"
import { query } from "~/utilities/trpc"

const BundlePage: FC = () => {
	const bundleId = parseNumber(useParams().bundleId) ?? -1

	const { data: bundle, error, refetch } = query.bundle.getPersonalized.useQuery(bundleId ?? -1)

	if (bundle === null) {
		return <Navigate to={routes.bundle.index()} />
	}

	return (
		<Layout>
			{error ? (
				<p>Failed to load bundle.</p>
			) : !bundle ? (
				<PartialLoadingPage />
			) : (
				<ProductDetail
					type="bundle"
					product={bundle}
					reload={refetch}
					unlockedContent={
						<Button variant="primary" isDisabled>
							You already own this bundle
						</Button>
					}
				/>
			)}
		</Layout>
	)
}

export default BundlePage
